import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { projects } from '../../data/portfolioProjects';
import { ProjectFrame } from '../portfolio/ProjectFrame';
const featuredNames = ['Atomic Apparel Designs', 'Lucky Duck Bathroom Company', 'CLR Marine'];
const featured = featuredNames.map(name => projects.find(p => p.name === name)).filter((p): p is (typeof projects)[number] => Boolean(p));
export function PortfolioTeaser() {
  return <section id="portfolio-teaser" className="relative overflow-hidden bg-navy-900 py-14 lg:py-20" data-id="element-188" data-mp="13e335a609ht6">
      <div className="absolute inset-0 dots opacity-[0.25]" aria-hidden="true" data-id="element-189" data-mp="yl9z6oid2di5" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-190" data-mp="tmoyyp33zttp">
        <div className="grid gap-5 lg:grid-cols-12 lg:items-end" data-id="element-191" data-mp="1r3nn9wdwal41">
          <div className="min-w-0 lg:col-span-7" data-id="element-192" data-mp="1r4ypvsvltmtk">
            <p className="font-mono text-[11.5px] uppercase tracking-[0.18em] text-forge-cyan" data-id="element-193" data-mp="1mbe02o45zz5g">Selected work</p>
            <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-[1.12] tracking-[-0.02em] text-white sm:text-[2.1rem]" data-id="element-194" data-mp="2ra0oh5g6ypyo">
              Real work shaped by real operating requirements.
            </h2>
          </div>
          <p className="min-w-0 text-[14.5px] leading-relaxed text-mist-200 lg:col-span-5" data-id="element-195" data-mp="2ieb7d8ls0hr3">
            Each project reflects a different customer journey, catalog, service model, and set of operational requirements.
          </p>
        </div>

        <div className="mt-9 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-196" data-mp="2dhku0t1cw09d">
          {featured.map((project, i) => <motion.article key={project.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className="min-w-0 overflow-hidden rounded-2xl border border-white/10 bg-navy-950/70" data-id="element-197" data-mp="1ziuwxdeje0l0" data-mpi={i}>
              <ProjectFrame project={project} size="large" data-id="element-198" data-mp="1aprsrstgchdu" />
              <div className="p-6" data-id="element-199" data-mp="15plwfzc8m6pf">
                <p className="font-mono text-[11.5px] uppercase tracking-[0.14em] text-mist-400" data-id="element-200" data-mp="15oklduv81k7p">{project.category}</p>
                <h3 className="mt-2 font-display text-[17px] font-bold leading-snug text-white" data-id="element-201" data-mp="11ok7cbc1bb16">{project.name}</h3>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-mist-300" data-id="element-202" data-mp="wqs3ciy47ygm">
                  <span className="font-semibold text-mist-100" data-id="element-203" data-mp="1teop028etjyp">Built to support: </span>
                  {project.supports}
                </p>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-7" data-id="element-204" data-mp="1kks3mpn2kbkc">
          <Link to="/portfolio" className="group inline-flex items-center gap-2 text-[14.5px] font-bold text-white transition-colors hover:text-forge-ember" data-id="element-205" data-mp="1fo1nk2b9lfyx">
            View selected work
            <ArrowUpRightIcon className="h-4 w-4 text-forge-orange transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-206" data-mp="28bfqch1n95qy" />
          </Link>
        </div>
      </div>
    </section>;
}